var emptyImage = "https://shopfront-cdn.tekoapis.com/static/e536f0592aa3c8b1.png";

export { emptyImage as default };
